<template>
  <Login>
    <template v-slot:title>
      <h2 class="white--text text-center mb-5">Consumer Channel Partner Rebate &amp; SPIFF Center</h2>
    </template>
    <template v-slot:register>
      <v-btn block type="button" color="primary" :to="{ name: 'CcprRegister' }">Register</v-btn>
    </template>
    <template v-slot:login_content>
      <p>
        This portal offers Sony’s Authorized Dealers and their Sales Representatives easy access to eligible incentive
        programs. If you have not received credentials, please click below to start the registration process.
      </p>
    </template>
  </Login>
</template>

<script>
import { mapGetters } from "vuex";
import Login from "../common/Login";

export default {
  name: "CcprLogin",
  metaInfo: {
    title: "Sony Channel Partner Login"
  },
  components: {
    Login
  },
  data() {
    return {
      program: null
    };
  },
  computed: {
    ...mapGetters(["selectedProgram"])
  }
};
</script>
